import React from 'react';
import styled from 'styled-components';
import {
  maxWidth, primaryFont, retina, wMBold,
} from 'Utils/utilsStyle';

type Props = {
  primaryHeading: string,
  secondaryHeading: string,
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  .left-side,.right-side {
    color: #424B50;
    font-family: ${primaryFont};
    font-size:16px;
    font-weight: ${wMBold};
    line-height: 47px;
    margin-bottom: 12px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
     font-size: 14px;
     margin-bottom: 8px;
    }
  }
`;

const EngagementTitle = function EngagementTitle(props: Props) {
  const { primaryHeading, secondaryHeading } = props;
  return (
    <Wrapper>
      <span className="left-side">{primaryHeading}</span>
      <span className="right-side">{secondaryHeading}</span>
    </Wrapper>
  );
};

export default EngagementTitle;
